import React from "react";

import { motion, animate } from "motion/react";

export const ValidationBackground = ({ showFloatingItems }) => {
  // Floating animation configuration
  const floatingAnimation = {
    x: [0, 10, 0],
    y: [0, -10, 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
  };

  const cloudAnimation = {
    x: [0, 500, 0],
    transition: {
      duration: 100, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
  };

  return (
    <div className="validation-background">
      <div style={{ overflow: "hidden" }}>
        <motion.img
          className="Img"
          style={{
            width: 1724,
            height: 941,
            left: -380,
            top: "40%",
            position: "absolute",
          }}
          src={require("../assets/img/cloud.png")}
          animate={cloudAnimation} // Apply floating animation
        />
        {showFloatingItems && (
          <div>
            <motion.img
              className="Bubble"
              style={{
                width: 120,
                height: 120,
                left: -86,
                top: 141,
                position: "absolute",
              }}
              src={require("../assets/img/bubble.png")}
              animate={floatingAnimation}
            />
            <motion.img
              className="Bubble"
              style={{
                width: 50,
                height: 50,
                left: 358,
                top: 151,
                position: "absolute",
                transform: "rotate(180deg)",
                transformOrigin: "0 0",
              }}
              src={require("../assets/img/bubble.png")}
              animate={floatingAnimation}
            />
            <motion.img
              className="Bubble"
              style={{
                width: 174,
                height: 174,
                left: -104,
                top: 786,
                position: "absolute",
              }}
              src={require("../assets/img/bubble.png")}
              animate={floatingAnimation}
            />
            <motion.img
              className="Img"
              style={{
                width: 1046,
                height: 747,
                left: 128,
                top: 206,
                position: "absolute",
              }}
              src={require("../assets/img/cloud.png")}
              animate={cloudAnimation}
            />
            <motion.img
              className="Bubble"
              style={{
                width: 249,
                height: 249,
                left: 321,
                top: 489,
                position: "absolute",
              }}
              src={require("../assets/img/cloud.png")}
              animate={cloudAnimation}
            />
          </div>
        )}
        <motion.div
          className="Heart3d"
          style={{
            width: 72,
            height: 72,
            left: 51,
            top: 515.93,
            position: "absolute",
            transform: "rotate(-11.16deg)",
            transformOrigin: "0 0",
            justifyContent: "center",
            alignItems: "center",
            display: "inline-flex",
          }}
          animate={floatingAnimation}
        >
          {showFloatingItems && (
            <motion.img
              className="Image110"
              style={{
                width: 58.79,
                height: 58.79,
                left: 0,
                top: 15.22,
                position: "absolute",
                transform: "rotate(-15deg)",
                transformOrigin: "0 0",
              }}
              src={require("../assets/img/heart-3d.png")}
              animate={floatingAnimation}
            />
          )}
        </motion.div>
        <motion.div
          className="Smiley3d"
          style={{
            width: 138,
            height: 138,
            paddingTop: 5,
            paddingBottom: 5.55,
            paddingLeft: 3,
            paddingRight: 3.51,
            left: 162,
            top: 221.72,
            position: "absolute",
            transform: "rotate(-15deg)",
            transformOrigin: "0 0",
            justifyContent: "center",
            alignItems: "center",
            display: "inline-flex",
          }}
          animate={floatingAnimation}
        >
          {showFloatingItems && (
            <motion.img
              className="Image109"
              style={{
                width: 131.49,
                height: 127.45,
                left: 0,
                top: 0,
                position: "absolute",
              }}
              src={require("../assets/img/smiley-3d.png")}
              animate={floatingAnimation}
            />
          )}
        </motion.div>
      </div>
    </div>
  );
};
